import React, { createContext, useContext, useState, useEffect } from 'react';

const PaperModeContext = createContext();

export const PaperModeProvider = ({ children }) => {
  const [paperMode, setPaperMode] = useState(() => {
    return localStorage.getItem('paperMode') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('paperMode', String(paperMode));
  }, [paperMode]);

  const togglePaperMode = () => setPaperMode(prev => !prev);

  return (
    <PaperModeContext.Provider value={{ paperMode, setPaperMode, togglePaperMode }}>
      {children}
    </PaperModeContext.Provider>
  );
};

export const usePaperMode = () => {
  const ctx = useContext(PaperModeContext);
  if (!ctx) throw new Error('usePaperMode must be used within PaperModeProvider');
  return ctx;
};
